module.exports = __webpack_public_path__ + "static/media/pamain.e4d1bda2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain.svg
// module id = ./src/assets/fonts/pamain.svg
// module chunks = 6